<script>
import EditUser from "../data/EditUser";
import PropertyTable from "../../../common/property-table.vue";
import DialogButton from "../../../dialog/components/dialog-button.vue";
import { customerLevels, translations } from "../data/variables";
import UserWizardProperty from "./user-wizard-property.vue";
import UserWizardErrorDisplay from "./user-wizard-error-display.vue";

export default {
        name: "user-wizard-done",
        components: {UserWizardErrorDisplay, UserWizardProperty, DialogButton, PropertyTable},
        props: {
            user: EditUser,
            errors: Array,
            errored: Boolean,
            processing: Boolean,
        },
        computed: {
            translations() {
                return translations;
            },
            projects() {
                this.user.getAllProjects();
            },
            displayedProjects() {
                return this.user.selectedProjects.map(project => {
                    const {privilegegroups, usergroups} = project;
                    const maxLen = _.max([privilegegroups.length, usergroups.length]);

                    const children = [];
                    for (let index = 0; index < maxLen; index++) {
                        children[index] = [usergroups[index], privilegegroups[index]];
                    }
                    return {...project, children };
                });
            },
            languages() {
                return Laravel.languages;
            },
            userLevel() {
                return customerLevels.find(level => level.value === this.user.level).text;
            },
        }
    }
</script>

<template>
    <div class="d-flex flex-row align-center justify-center h-100 overflow-y-hidden">
        <div v-if="errored"
            class="d-flex align-center justify-center"
        >
            <user-wizard-error-display
                :errors="errors"
                :user="this.user"
            />
        </div>
        <div v-else class="d-flex flex-row w-100 h-100">
            <div class="d-flex flex-column flex-grow-1">
                <h4>{{translations.general}}</h4>
                <div class="wizard-box">
                    <user-wizard-property :property="translations.firstName" :value="user.firstName"/>
                    <user-wizard-property :property="translations.lastName" :value="user.lastName"/>
                    <user-wizard-property :property="translations.email" :value="user.email"/>
                    <user-wizard-property :property="translations.language" :value="languages[user.language]"/>
                </div>
                <div class="wizard-box">
                    <user-wizard-property :property="translations.customerName" :value="user.customerName"/>
                    <user-wizard-property :property="translations.customerExternalId" :value="user.customerExternalId"/>
                    <user-wizard-property :property="translations.levels" :value="userLevel"/>
                </div>
                <div class="wizard-box">
                    <user-wizard-property :property="translations.publishNotification" :value="user.getPublishNotificationDisplayText()"/>
                    <user-wizard-property :property="translations.tagSearch" :value="user.getTagSearchDisplayText()"/>
                    <user-wizard-property :property="translations.timepickerMode" :value="user.getTimepickerModeDisplayText()"/>
                </div>
            </div>
            <div class="d-flex flex-column w-50">
                <h4>{{`${translations.projects} & ${translations.grouping}`}}</h4>
                <property-table
                    disableHeader
                    :items="displayedProjects"
                    :propertyName="translations.projects"
                    readOnly
                />
            </div>
        </div>
    </div>
</template>

<style scoped>
    .wizard-box {
        margin: 4px;
    }
</style>
